import { ICON__circle_solid } from '@/assets/icons_fa';
import { cn } from '@/utils/utils_client';
import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';
import * as React from 'react';

export interface PROPS extends React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item> {
  class_name_icon?: string;
  class_name_indicator?: string;
}

export const UI_PRIMITIVE__radio_group_item = React.forwardRef<React.ElementRef<typeof RadioGroupPrimitive.Item>, PROPS>(
  ({ className, class_name_icon, class_name_indicator, ...props }, ref) => {
    return (
      <RadioGroupPrimitive.Item
        ref={ref}
        className={cn(
          'aspect-square h-4 w-4 rounded-full border  border-neutral-900 text-neutral-900 ring-offset-white focus:outline-none focus-visible:ring-2 focus-visible:ring-neutral-950 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 dark:border-neutral-800 dark:border-neutral-50 dark:text-neutral-50 dark:ring-offset-neutral-950 dark:focus-visible:ring-neutral-300',
          className,
        )}
        {...props}
      >
        <RadioGroupPrimitive.Indicator className={cn(`flex-center`, class_name_indicator)}>
          <ICON__circle_solid className={cn('size-2 fill-current text-current', class_name_icon)} />
        </RadioGroupPrimitive.Indicator>
      </RadioGroupPrimitive.Item>
    );
  },
);
UI_PRIMITIVE__radio_group_item.displayName = RadioGroupPrimitive.Item.displayName;
